// 自定义组件
import msg from './msg'
import confirm from './confirm'
import reLogin from './re-login'
import modal from './modal'
import radio from './form/radio.vue'
import checkbox from './form/checkbox.vue'
import toggle from './form/toggle.vue'

// 待实现...暂时引用 vue-strap 组件
import alert from './vue-strap/Alert.vue'
import carousel from './vue-strap/Carousel.vue'
import slider from './vue-strap/Slider.vue'
import accordion from './vue-strap/Accordion.vue'
import affix from './vue-strap/Affix.vue'
import aside from './vue-strap/Aside.vue'
import checkboxGroup from './vue-strap/checkboxGroup.vue'
import checkboxBtn from './vue-strap/checkboxBtn.vue'
import datepicker from './vue-strap/Datepicker.vue'
import dropdown from './vue-strap/Dropdown.vue'
import option from './vue-strap/Option.vue'
import panel from './vue-strap/Panel.vue'
import popover from './vue-strap/Popover.vue'
import progressbar from './vue-strap/Progressbar.vue'
import radioBtn from './vue-strap/radioBtn.vue'
import radioGroup from './vue-strap/radioGroup.vue'
import select from './vue-strap/Select.vue'
import tab from './vue-strap/Tab.vue'
import tabset from './vue-strap/Tabset.vue'
import typeahead from './vue-strap/Typeahead.vue'
import tabMenu from './tab-menu'

// 异步组件: Webpack 会将这些组件打包成独立且异步加载的 js 文件
const vCode = (resolve) => {
    require([ './v-code' ], resolve)
}
const codeEditor = (resolve) => {
    require([ './code-editor' ], resolve)
}

export {
  // components from vue-strap
  alert, carousel, slider, accordion, affix, aside, checkboxGroup, checkboxBtn,
  datepicker, dropdown, option, panel, popover, progressbar, radioBtn,
  radioGroup, select, tab, tabset, typeahead,
  // self implements
  msg, confirm, reLogin, vCode, modal, radio, checkbox, toggle,
  // 异步组件
  codeEditor, tabMenu
}


// WEBPACK FOOTER //
// ./bootsets/components/index.js